import { i18n } from "..";

export enum TravelInsuranceRangeEnum {
  TEN_TWENTY = 'tenToTwenty',
  TWENTY_FORTHY = 'twentyToForthy',
  FORTHY_TO_SIXTY = 'forthyToSixty',
  MORE_THAN_SIXTY = 'moreThanSixty'
}

export const TravelInsuranceRangeEnumLabel = {
  [TravelInsuranceRangeEnum.TEN_TWENTY]: i18n.t('common.constants.travelInsuranceRanges.tenToTwenty'),
  [TravelInsuranceRangeEnum.TWENTY_FORTHY]: i18n.t('common.constants.travelInsuranceRanges.twentyToForthy'),
  [TravelInsuranceRangeEnum.FORTHY_TO_SIXTY]: i18n.t('common.constants.travelInsuranceRanges.forthyToSixty'),
  [TravelInsuranceRangeEnum.MORE_THAN_SIXTY]: i18n.t('common.constants.travelInsuranceRanges.moreThanSixty')
}